import { Fragment, useState } from "react";

import { BrandLockup } from "../../components/common/BrandLockup";
import { Footer } from "../../components/common/Footer";
import { BeautyCalculator } from "./BeautyCalculator";
import { BeautyFaq } from "./BeautyFaq";
import { BeautyPlans } from "./BeautyPlans";

export function BeautyPage() {
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <div className="beauty-page">
      <nav className="nav">
        <BrandLockup pills={["GO", "Beauty"]} />
        <div className="nav-right">
          <a href="#planos" className="nav-link">Planos</a>
          <a href="#faq" className="nav-link">Dúvidas</a>
          <a href="/go/start" className="nav-cta">Começar 7 dias grátis</a>
        </div>
      </nav>

      <div className="hero">
        <div className="hero-left">
          <div className="hero-kicker f1">
            <span className="hero-kicker-dot"></span>Agenda, clientes e rotina Beauty
          </div>
          <h1 className="hero-h1 f2">
            Sua agenda<br />organizada.<br />Seu time <em>atendendo.</em>
          </h1>
          <p className="hero-sub f3">
            THH GO organiza horários, profissionais, clientes e retornos para salões e profissionais que não podem depender do improviso.
          </p>
          <div className="hero-readiness f3" aria-label="O que a primeira versão organiza">
            <span>Cliente agenda sem criar conta</span>
            <span>Equipe vê a mesma rotina</span>
            <span>Histórico fica ligado ao atendimento</span>
          </div>
          <div className="pain-chips f3">
            {["Agenda no caderno", "Falta sem aviso", "Confirmação manual", "Cliente que some", "Conflito de horário"].map((pain) => (
              <span className="chip" key={pain}><span className="chip-x">x</span>{pain}</span>
            ))}
          </div>
          <div className="hero-cta-block f4">
            <div className="hero-cta-row">
              <a href="/go/start" className="btn-primary">Começar 7 dias grátis</a>
              <a href="#como-funciona" className="btn-ghost">Como funciona <span className="btn-ghost-arrow">-&gt;</span></a>
            </div>
            <div className="hero-trust">
              <span className="hero-trust-dot"></span>
              Fluxo guiado para Beauty Solo e Team. Você vê plano, rotina inicial e próximos passos antes de ativar.
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="phone-mockup f6">
            <div className="phone-label">THH GO · rotina do dia</div>
            <div style={{ position: "relative" }}>
              <div className="notif-bubble">Mariana confirmou às 09h00</div>
              <div className="phone-shell">
                <div className="phone-topbar">
                  <div className="ph-dot" style={{ background: "#ff5f57" }}></div>
                  <div className="ph-dot" style={{ background: "#febc2e" }}></div>
                  <div className="ph-dot" style={{ background: "#28c840" }}></div>
                </div>
                <div className="phone-content">
                  <div className="ph-greeting">Quinta, 17 de abril</div>
                  <div className="ph-today">Bom dia, Ana</div>
                  {[
                    ["Mariana Costa", "Corte + escova", "09:00", "R$ 120", ""],
                    ["Juliana Ramos", "Coloração completa", "10:30", "R$ 220", "green"],
                    ["Fernanda Lima", "Hidratação profunda", "13:00", "R$ 90", "dim"]
                  ].map(([client, service, time, price, tone]) => (
                    <div className={`ph-appt ${tone}`} key={`${client}-${time}`}>
                      <div className="ph-appt-l">
                        <div className="ph-name">{client}</div>
                        <div className="ph-svc">{service}</div>
                      </div>
                      <div className="ph-appt-r">
                        <div className="ph-time">{time}</div>
                        <div className="ph-price">{price}</div>
                      </div>
                    </div>
                  ))}
                  <div className="ph-strip">
                    <div className="ph-s"><div className="ph-sv">R$920</div><div className="ph-sl">Hoje</div><div className="ph-sd">+14%</div></div>
                    <div className="ph-s"><div className="ph-sv">8</div><div className="ph-sl">Agendados</div><div className="ph-sd">dia</div></div>
                    <div className="ph-s"><div className="ph-sv">2</div><div className="ph-sl">Retornos</div><div className="ph-sd">30d</div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="proof-bar">
        <div className="proof-inner">
          <div className="proof-intro">
            <span>Rotina profissional</span>
            <strong>Menos improviso nos pontos que mais travam a agenda.</strong>
          </div>
          <div className="proof-items">
            <div className="proof-item"><span className="proof-icon"></span><strong>Agenda sem conflito</strong><small>Horários calculados por profissional.</small></div>
            <div className="proof-item"><span className="proof-icon"></span><strong>Confirmação opcional</strong><small>O estabelecimento decide se quer ativar.</small></div>
            <div className="proof-item"><span className="proof-icon"></span><strong>Cliente com histórico</strong><small>Atendimentos e preferências salvos.</small></div>
            <div className="proof-item"><span className="proof-icon"></span><strong>Avaliação depois do serviço</strong><small>Feedback conectado ao atendimento.</small></div>
          </div>
        </div>
      </div>

      <BeautyCalculator />

      <section className="dor-sec">
        <div className="sec-kicker">O problema</div>
        <h2 className="sec-h">Você se reconhece aqui?</h2>
        <p className="sec-sub">A maioria dos profissionais de beleza perde tempo e dinheiro com problemas que podem ser organizados.</p>
        <div className="dor-grid reveal">
          <div className="dor-before">
            <div className="dor-head before">Sem o THH GO</div>
            <div className="dor-items">
              {[
                ["Confirmação manual no WhatsApp", "Tempo perdido confirmando horário por mensagem. Cliente que não responde, você que fica esperando."],
                ["Falta sem aviso", "Horário bloqueado, cadeira vazia e receita que some. Sem registro, sem histórico, sem controle."],
                ["Agenda no caderno ou planilha", "Horário duplicado, horário errado e profissional sem saber o que vem a seguir."],
                ["Sem visão sobre clientes", "Não sabe quem voltou, quem sumiu, o que cada cliente prefere ou quanto gerou."]
              ].map(([title, text]) => (
                <div className="dor-item" key={title}>
                  <div className="dor-ico red">x</div>
                  <div className="dor-txt">
                    <div className="dor-title">{title}</div>
                    <div className="dor-desc">{text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="dor-after">
            <div className="dor-head after">Com o THH GO</div>
            <div className="dor-items">
              {[
                ["Link de agendamento online", "Cliente acessa, escolhe serviço e horário disponível. Você reduz conversa repetitiva."],
                ["Lembretes configuráveis", "Avisos antes do horário marcado quando o canal estiver habilitado pelo estabelecimento."],
                ["Agenda interna sem conflito", "Horários calculados por profissional. Sem dois clientes no mesmo período para a mesma pessoa."],
                ["Histórico de clientes", "Serviço, profissional, data, frequência e avaliação ficam conectados ao atendimento."]
              ].map(([title, text]) => (
                <div className="dor-item" key={title}>
                  <div className="dor-ico grn">✓</div>
                  <div className="dor-txt">
                    <div className="dor-title">{title}</div>
                    <div className="dor-desc">{text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="feat-sec">
        <div className="sec-kicker">O produto</div>
        <h2 className="sec-h">Tudo que você precisa.<br />Sem o que você não usa.</h2>
        <p className="sec-sub">Funcionalidades reais para organizar agenda, cliente, equipe e atendimento sem complicar a rotina.</p>
        <div className="feat-grid reveal">
          {[
            ["01", "Agendamento online", "Seu link personalizado. Cliente escolhe serviço, profissional quando habilitado e horário disponível.", "Essencial"],
            ["02", "Agenda interna operacional", "Reservas, remarcações e bloqueios de horário sem conflito para o mesmo profissional.", "Essencial"],
            ["03", "Histórico de clientes", "Atendimentos, serviços, profissional, status e preferências ficam organizados.", "Essencial"],
            ["04", "WhatsApp como apoio", "Pedidos recebidos no WhatsApp podem ser direcionados para o link de agendamento, reduzindo conversa manual.", "Em evolução"],
            ["05", "Falta sem aviso registrada", "Quando o cliente não aparece, isso fica no histórico sem virar cancelamento.", "Diferencial"],
            ["06", "Avaliação pós-atendimento", "Feedback simples depois do serviço, ligado ao profissional e ao atendimento real.", "Diferencial"]
          ].map(([number, title, text, badge]) => (
            <article className={`feat-card${number === "01" ? " highlight" : ""}`} key={number}>
              <div className="feat-num">{number}</div>
              <div className="feat-title">{title}</div>
              <div className="feat-desc">{text}</div>
              <span className={`feat-tag ${badge === "Essencial" ? "tag-hot" : "tag-new"}`}>{badge}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="how-sec" id="como-funciona">
        <div className="sec-kicker">Como funciona</div>
        <h2 className="sec-h">Comece pelo essencial,<br />sem implantação pesada.</h2>
        <p className="sec-sub">O primeiro valor é simples: serviço publicado, agenda disponível, cliente conseguindo pedir horário e equipe olhando a mesma rotina.</p>
        <div className="steps reveal">
          {[
            ["01 -", "Configure o básico", "Cadastre serviços, duração, preço e disponibilidade para a agenda começar correta."],
            ["02 -", "Compartilhe seu link", "Use no Instagram, Google ou WhatsApp. O cliente pede horário sem precisar criar conta."],
            ["03 -", "Atenda com contexto", "Agenda, status e histórico ficam na mesma operação enquanto a equipe trabalha."]
          ].map(([number, title, text], index) => (
            <div className="step" key={number}>
              <div className="step-n">{number}</div>
              <div className="step-title">{title}</div>
              <div className="step-desc">{text}</div>
              {index < 2 && <div className="step-connector">-&gt;</div>}
            </div>
          ))}
        </div>
      </section>

      <BeautyPlans isAnnual={isAnnual} onBillingChange={setIsAnnual} />

      <section className="social-sec">
        <div className="sec-kicker">Cenários de operação</div>
        <h2 className="sec-h">O produto precisa fazer sentido em rotinas reais.</h2>
        <div className="social-grid reveal">
          {[
            ["Operação solo", "Cabelo e beleza · profissional individual", "A agenda precisa reduzir pergunta repetida no WhatsApp e deixar claro quais horários ainda podem ser ocupados."],
            ["Equipe pequena", "Esmalteria ou barbearia · agenda por profissional", "O dono precisa saber quem está livre, quem faltou e quem precisa remarcar sem juntar informações em conversas soltas."],
            ["Salão em crescimento", "Equipe maior · mais controle", "A gestão precisa enxergar atendimento, retorno, falta sem aviso e histórico sem depender da memória de uma pessoa."]
          ].map(([name, role, quote], index) => (
            <Fragment key={name}>
              {index > 0 && <div className="social-rule" />}
              <div className="testimonial">
                <div className="test-stars">Caso {String(index + 1).padStart(2, "0")}</div>
                <p className="test-quote">{quote}</p>
                <div className="test-author">
                  <div className="test-avatar">{index === 0 ? "SO" : index === 1 ? "EQ" : "SL"}</div>
                  <div>
                    <div className="test-name">{name}</div>
                    <div className="test-role">{role}</div>
                  </div>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </section>

      <BeautyFaq />

      <section className="cta-final" id="trial">
        <div className="sec-kicker">Comece hoje</div>
        <h2 className="cta-h-final">Coloque a rotina da beleza em um lugar só.</h2>
        <p className="cta-sub-final">Comece pelo fluxo guiado, veja o plano indicado para sua operação e avance sem prometer mais do que a equipe consegue usar agora.</p>
        <a className="cta-btn-final" href="/go/start">Começar 7 dias grátis</a>
        <div className="cta-final-trust">
          <span>Plano claro antes da ativação</span>
          <span>Agenda e clientes no mesmo fluxo</span>
          <span>Beauty Solo e Team como primeira entrada</span>
          <span>Preparado para crescer com controle</span>
        </div>
      </section>

      <Footer
        brand="THH GO · Beauty"
        message="THH · Gestão operacional para beleza"
        links={[
          { href: "#", label: "Termos de uso" },
          { href: "#", label: "Privacidade" },
          { href: "https://thh.com.br", label: "thh.com.br" }
        ]}
      />
    </div>
  );
}
